import { generateUtilityClass, generateUtilityClasses } from "@kaltura/mediaspace-shared-styled";

import { composeClasses } from "@kaltura/mediaspace-shared-styled";

export function getSiteRegistrationFieldClass(slot: string) {
    return generateUtilityClass("kms-ds-site-registration-field", slot);
}

export interface SiteRegistrationFieldClasses {
    /**  styles applied to the root element */
    root: string;
    /**  styles applied to the label element */
    label: string;
    /**  styles applied to the input element */
    input: string;
    /**  styles applied to the error element */
    error: string;
}

export type SiteRegistrationFieldClassKey = keyof SiteRegistrationFieldClasses;

export const siteRegistrationFieldClasses = generateUtilityClasses(
    "kms-ds-site-registration-field",
    ["root", "label", "input", "input", "error"]
);

export default siteRegistrationFieldClasses;

export const useUtilityClasses = () => {
    const slots = {
        root: ["root"],
        label: ["label"],
        input: ["input"],
        error: ["error"],
    };

    return composeClasses(slots, getSiteRegistrationFieldClass);
};
